<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgment">
<h1 style="padding-bottom: 40px;">Acknowledgment</h1>
<p style="text-align: center;">Thanks to Austin Macauley Publishers for guiding me on each and every step of publishing.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?dfce2946